import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteFabricsMutationProps = {
	ids: number[]
	onSettled: () => void
}

export const useDeleteFabricsMutation = ({ ids, onSettled }: UseDeleteFabricsMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: deleteFabricsMutation } = useMutation({
		mutationFn: () => {
			return axiosPrivate.post(apiRoutes.fabricsDelete, { ids })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Fabrics deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.fabrics.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteFabricsMutation
	}
}
